import styled from "styled-components";

const Card = styled.div`
  background: #16406a;
  backdrop-filter: blur(10px);
  border-radius: 5px;
  text-align: center;
  opacity: 1;
  color: white;
  border-left: 2px solid transparent;
  border-right: 2px solid transparent;

  &:hover {
    border-left: 2px solid rgba(255, 255, 255, 0.6);
    border-right: 2px solid rgba(255, 255, 255, 0.6);
  }
`;

const Image = styled.img`
  width: 150px;
  height: 165px;
  border-radius: 10%;
  object-fit: cover;
  border: 4px solid #205f9c;
  margin-top: -42px;
`;

const Name = styled.p`
  color: white;
  font-size: 1.1rem;
  margin: 0;
  font-family: "Inter", sans-serif;
`;

const Role = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-family: "Inter", sans-serif;
  margin-block: 0px;
  font-size: 0.8rem;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;

  a {
    color: white;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  svg {
    flex-shrink: 0;
    border-radius: 50%;
    font-size: 0.5rem;
    padding: 5px;
    background-color: #205f9c;
  }
`;

const HrTag = styled.hr`
  height: 1px;
  background: #205f9c;
  border: none;
  border-radius: 2px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
`;

const SC = {
  Card,
  Image,
  Name,
  Role,
  SocialLinks,
  HrTag,
};

export default SC;
